import { PROFILE_ROUTE_NAMES } from '../../constants/route'

export function getRequestThreadPrintPageLink({
  additionalParams,
  id,
  outboundUuid,
  requestId,
}) {
  return outboundUuid
    ? PROFILE_ROUTE_NAMES.connectedRequestThreadPrint({
        additionalParams,
        id,
        outboundUuid,
        requestId,
      })
    : PROFILE_ROUTE_NAMES.requestThreadPrint({
        additionalParams,
        id,
        requestId,
      })
}

export function getRequestThreadMessagePrintPageLink({
  additionalParams,
  id,
  outboundUuid,
  requestId,
}) {
  return outboundUuid
    ? PROFILE_ROUTE_NAMES.connectedRequestThreadMessagePrint({
        additionalParams,
        id,
        outboundUuid,
        requestId,
      })
    : PROFILE_ROUTE_NAMES.requestThreadMessagePrint({
        additionalParams,
        id,
        requestId,
      })
}

export function getRequestThreadMessageRawPageLink({
  additionalParams,
  id,
  outboundUuid,
  requestId,
}) {
  return outboundUuid
    ? PROFILE_ROUTE_NAMES.connectedRequestThreadMessageRaw({
        additionalParams,
        id,
        outboundUuid,
        requestId,
      })
    : PROFILE_ROUTE_NAMES.requestThreadMessageRaw({
        additionalParams,
        id,
        requestId,
      })
}
